export default __webpack_public_path__ + "static/media/ic_filter.5edb32f8.svg";